import script from "./addOrg.vue?vue&type=script&setup=true&lang=js"
export * from "./addOrg.vue?vue&type=script&setup=true&lang=js"

import "./addOrg.vue?vue&type=style&index=0&id=7b5e03d8&lang=scss"

const __exports__ = script;

export default __exports__